export const testimonials = [
  {
    id: 1,
    name: "Sarah Thompson",
    location: "Caterham, Surrey",
    rating: 5,
    date: "February 2026",
    text: "Absolutely delighted with our new bifold doors from Ensure Windows. The team was professional from first quote to final installation. The doors look stunning and have completely transformed our kitchen extension. Highly recommended to anyone in the area.",
    product: "Aluminium Bifold Doors",
    avatar: "ST",
  },
  {
    id: 2,
    name: "James & Lucy Harrington",
    location: "Redhill, Surrey",
    rating: 5,
    date: "January 2026",
    text: "We had all our windows replaced with uPVC throughout the house. The difference in warmth and noise reduction has been remarkable. Ensure Windows provided excellent advice, fair pricing, and completed the work with minimal disruption. Five stars without hesitation.",
    product: "uPVC Windows",
    avatar: "JH",
  },
  {
    id: 3,
    name: "David Patel",
    location: "Warlingham, Surrey",
    rating: 5,
    date: "January 2026",
    text: "Our composite front door has made such a difference to the look of the house. The team helped us choose the perfect style and colour. Installation was quick, clean, and professional. We have already recommended Ensure Windows to three neighbours.",
    product: "Composite Door",
    avatar: "DP",
  },
  {
    id: 4,
    name: "Margaret Collins",
    location: "Oxted, Surrey",
    rating: 5,
    date: "December 2025",
    text: "I had a conservatory installed last autumn and I could not be happier. It is warm enough to use all year round and the quality of the build is exceptional. The planning and installation team were knowledgeable, tidy, and kept me informed throughout.",
    product: "Conservatory",
    avatar: "MC",
  },
  {
    id: 5,
    name: "Robert & Emma Finch",
    location: "Purley, South London",
    rating: 5,
    date: "November 2025",
    text: "Ensure Windows replaced all the windows in our Victorian terrace with beautiful slim aluminium frames. The attention to detail was excellent and they clearly care about getting the job right. The whole house feels brighter and more modern.",
    product: "Aluminium Windows",
    avatar: "RF",
  },
  {
    id: 6,
    name: "Chris Donaldson",
    location: "Coulsdon, Surrey",
    rating: 5,
    date: "October 2025",
    text: "Fantastic service from start to finish. The roof lantern on our kitchen extension is the centrepiece of the room. Ensure Windows handled everything including the building regulations sign-off. Truly a stress-free experience.",
    product: "Roof Lantern",
    avatar: "CD",
  },
  {
    id: 7,
    name: "Fiona Hughes",
    location: "Kenley, Surrey",
    rating: 4,
    date: "September 2025",
    text: "Very pleased with the patio sliding doors. The installation team were friendly and efficient, completing the job in a single day. The doors glide perfectly and have made such a difference to our lounge. Great value for the quality provided.",
    product: "Patio Sliding Doors",
    avatar: "FH",
  },
  {
    id: 8,
    name: "Andrew & Kate Morrison",
    location: "Whyteleafe, Surrey",
    rating: 5,
    date: "August 2025",
    text: "We replaced our old French doors and three windows with Ensure Windows. The quality of materials is clearly superior to what we had before. The surveyor took his time measuring up and the finished result was perfect. Would absolutely use again.",
    product: "French Doors",
    avatar: "AM",
  },
];

export const stats = [
  { value: "500+", label: "Projects Completed" },
  { value: "12+", label: "Years Experience" },
  { value: "4.9/5", label: "Average Rating" },
  { value: "100%", label: "Satisfaction Guaranteed" },
];
